import { render, staticRenderFns } from "./PPanelProperties.vue?vue&type=template&id=008990f2"
import script from "./PPanelProperties.vue?vue&type=script&lang=js"
export * from "./PPanelProperties.vue?vue&type=script&lang=js"
import style0 from "./PPanelProperties.vue?vue&type=style&index=0&id=008990f2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports